export default __webpack_public_path__ + "static/media/my-friends.54057434.svg";